module.exports = __webpack_public_path__ + "media/images/arrow-left-1d22ec0fd46274cb680fb1396a709dd4.svg";